import React, { useEffect, useState } from 'react'
import { toast } from '@CommonComponents/toast'
import { client } from '@Utils'
import { withRouter } from 'react-router-dom'
import { useStateValue } from '@State'
import { history } from './App'

const DetailsComp = ({ match }) => {
  const [currentState] = useStateValue()
  const [courseData, setCourseData] = useState([])
  const [cnumList, setCnumList] = useState([])
  const [nonExist, setNonExist] = useState([])
  const [alreadyRelated, setAlreadyRelated] = useState([])

  let acctId = match.params.acctId
  let acct = currentState.invoiceAccts.filter(ia => ia[0] === acctId)[0]

  useEffect(() => {
    getCourseData()
  }, [])

  const getCourseData = async () => {
    try {
      let resp = await client.get(
        `/account/invoice_account_enrollment.get_ia_course_data/${acctId}`
      )
      setCourseData(resp.data.data)
    } catch (err) {
      toast.error(`There was an error retrieving the account data. ${err}`)
    }
  }

  const relateAccountAndCourses = async () => {
    try {
      let resp = await client.post(
        '/account/invoice_account_enrollment.add_courses_to_account',
        { acctId: acctId, coursenums: cnumList }
      )
      setNonExist(resp.data.nonExist)
      setAlreadyRelated(resp.data.alreadyRelated)
      getCourseData()
    } catch (err) {
      toast.error(`There was an error trying to add courses to the invoice account. ${err}`)
    }
  }

  return (
    <React.Fragment>
      <button
        className="btn btn-myed btn-default btn-myed-default ml-4"
        onClick={history.goBack}
      >
        <i className="fa-regular fa-long-arrow-left" /> Back
      </button>
      <div className="card-myed">
        <div className="d-flex">
          <h2 className="w-50">{acct[1]}</h2>
          <div className="d-flex">
            <div>
              <b>Add courses by list of course numbers: </b>
              <textarea
                className="form-control"
                rows="3"
                cols="50"
                onChange={e => setCnumList(e.target.value)}
              />
            </div>
            <div className="align-self-center">
              <button
                className="btn btn-myed btn-primary ml-3 mt-4"
                onClick={relateAccountAndCourses}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
        {(nonExist.length > 0 || alreadyRelated.length > 0) && (
          <div className="d-flex justify-content-center">
            {nonExist.length > 0 && (
              <div className="w-25 mr-4">
                <b className="text-danger">Nonexistent Course Numbers</b>
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>Course Numbers</th>
                    </tr>
                  </thead>
                  <tbody>
                    {nonExist.map(cnum => (
                      <tr key={cnum}>
                        <td>{cnum}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            {alreadyRelated.length > 0 && (
              <div className="w-50">
                <b className="text-danger">Already-Assigned Course Numbers</b>
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>Course Number</th>
                      <th>Invoice Account Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {alreadyRelated.map((item, i) => (
                      <tr key={i}>
                        <td>{item[0]}</td>
                        <td>{item[1]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}
        <div className="ml-5">
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Course Number</th>
                <th>Course Title</th>
                <th>School</th>
              </tr>
            </thead>
            <tbody>
              {courseData.map((item, i) => (
                <tr key={i}>
                  <td style={{ width: '20%' }}>{item.coursenum}</td>
                  <td style={{ width: '40%' }}>{item.courseTitle}</td>
                  <td style={{ width: '40%' }}>{item.school}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </React.Fragment>
  )
}

export const Details = withRouter(DetailsComp)
